import EvenInArcadiaImage from '../../assets/albums/covers/even_in_arcadia.jpg';
import VinylAlbum from './VinylAlbum';

function EvenInArcadia({ albumRef, delay, onClick, isPlaying }) {
  return (
    <VinylAlbum
      image={EvenInArcadiaImage}
      alt="Even in Arcadia"
      isPlaying={isPlaying}
      onClick={onClick}
      albumRef={albumRef}
      delay={delay}
    />
  );
}

export default EvenInArcadia;